import { useSelector } from 'react-redux';
import { OrderItem, OrderItemType } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import { Tag } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getServiceTimeUnitSingularKey } from '@mews-commander/legacy-entities/src/utils/serviceTimeUnitLocalization';
import { getServiceByServiceOrderId } from '../../../billing/selectors';

interface OrderItemTypeTagProps {
    orderItem: OrderItem;
}

const OrderItemTypeTag = ({ orderItem }: OrderItemTypeTagProps) => {
    const serviceTimeKey = useSelector((state: ApplicationState) => {
        const service = getServiceByServiceOrderId(state, { serviceOrderId: orderItem.serviceOrderId });
        return service ? getServiceTimeUnitSingularKey(state, { id: service.id }) : undefined;
    });

    const getLocalizedTextKey = () => {
        switch (orderItem.data.discriminator) {
            case OrderItemType.CancellationFee:
                return TextKey.OrderItemTypeCancellationFee;
            case OrderItemType.NightRebate:
            case OrderItemType.ProductOrderRebate:
            case OrderItemType.AdditionalExpenseRebate:
                return TextKey.Rebate;
            case OrderItemType.Deposit:
                return TextKey.OrderItemTypeDeposit;
            case OrderItemType.ExchangeRateDifference:
                return TextKey.OrderItemTypeExchangeRateDifference;
            case OrderItemType.CustomItem:
                return TextKey.OrderItemTypeCustomItem;
            case OrderItemType.ServiceCharge:
                return TextKey.OrderItemTypeServiceCharge;
            case OrderItemType.CityTax:
                return TextKey.OrderItemTypeCityTax;
            case OrderItemType.CityTaxDiscount:
                return TextKey.OrderItemTypeCityTaxDiscount;
            case OrderItemType.ProductOrder:
                return TextKey.Product;
            case OrderItemType.Surcharge:
                return TextKey.OrderItemTypeSurcharge;
            case OrderItemType.MulticurrencyFee:
                return TextKey.OrderItemTypeMulticurrencyFee;
            case OrderItemType.SpaceOrder:
                return serviceTimeKey || TextKey.Space;
            default:
                return TextKey.Product;
        }
    };

    return (
        <Tag variant="basicSubtle">
            <LocalizedText textKey={getLocalizedTextKey()} />
        </Tag>
    );
};

export default OrderItemTypeTag;
